import SessionStorageService from "@/services/SessionStorageService";

export async function httpFetch(url, options = {}) {
    const token = SessionStorageService.getItem("idToken"); 

    const headers = {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    };
  
    const config = { ...options, headers };

    const response =  await fetch(url, config);
 
    if (!response.ok) {
      const errorBody = await response.clone().json().catch(() => ({}));
      throw Object.assign({
        status: errorBody.status,
        title: errorBody.title,
        detail: errorBody.detail
      });
    }
     
    return response;
      
  }
  